export const enum TerritoryActiveFilter {
  all = 'all',
  posts = 'posts',
  prompts = 'prompts',
  byYou = 'By You',
  youveRead = 'You’ve Read',
  livePrompts = 'Live Prompts',
  active = 'Active',
  completed = 'Completed',
  upcoming = 'Upcoming',
}

export const enum TerritoryActiveMainFilter {
  all = 'all',
  posts = 'posts',
  prompts = 'prompts',
}

export const enum TerritoryPostActiveFilter {
  author = 'me',
  status = 'read',
}

export const enum TerritoryPromptActiveFilter {
  author = 'me',
  status = 'live',
}

export const enum TerritoryLivePromptActiveFilter {
  active = 'active',
  upcoming = 'upcoming',
  completed = 'completed',
}

export const MAIN_FILTER_BUTTONS_LIST = [
  { label: 'All', value: TerritoryActiveMainFilter.all },
  { label: 'Posts', value: TerritoryActiveMainFilter.posts },
  { label: 'Prompts', value: TerritoryActiveMainFilter.prompts },
];

export const POST_FILTER_BUTTON_LIST = [
  { label: 'By You', value: TerritoryPostActiveFilter.author },
  { label: "You've Read", value: TerritoryPostActiveFilter.status },
];

export const PROMPT_FILTER_BUTTON_LIST = [
  { label: 'By You', value: TerritoryPromptActiveFilter.author },
  { label: 'Live Prompts', value: TerritoryPromptActiveFilter.status },
];

export const LIVE_PROMPT_FILTER_BUTTON_LIST = [
  { label: 'Active', value: TerritoryLivePromptActiveFilter.active },
  { label: 'Upcoming', value: TerritoryLivePromptActiveFilter.upcoming },
  { label: 'Completed', value: TerritoryLivePromptActiveFilter.completed },
];

export const postFilterToQueryKeyMap: Record<TerritoryPostActiveFilter, string> = {
  [TerritoryPostActiveFilter.author]: 'post-author',
  [TerritoryPostActiveFilter.status]: 'post-status',
};

export const promptFilterToQueryKeyMap: Record<TerritoryPromptActiveFilter, string> = {
  [TerritoryPromptActiveFilter.author]: 'prompt-author',
  [TerritoryPromptActiveFilter.status]: 'prompt-status',
};
